<!-- Below code is tested on SheetJS v0.14.0 -->
<template>
        <s-button theme="is-info is-small" 
                        label="Export" icon="file-excel"
                        afterIcon="file-download"
                        @onclick="onexport"
                />
</template>

<script>
import XLSX from 'xlsx'
import firebase_api from "@/firebase/firebase_api"
export default {
   props: ['club'],
  data: () => ({
      membres: []
  }),
  computed: {
        nameFile: {
            get() {
                const event = new Date();
                const options = {  year: 'numeric', month: 'long', day: 'numeric' };
                return 'Export Membres -' + this.club.name + '-' + event.toLocaleDateString('fr-FR', options) + '.xlsx';
            }
        }
    },
  methods: {
      async loadData() {
           
            this.progress = true;
            
        var joueurDocs = await firebase_api.api.getDb().collection("club").doc(this.club.id).collection("joueurs").get()
        joueurDocs.docs.forEach((doc, index)=>{
                    var ligne = {};
                    ligne.ID = doc.id;
                    ligne.PSEUDO = doc.data().pseudo;
                    ligne.NOM = doc.data().nom;
                    ligne.PRENOM = doc.data().prenom;
                    ligne.ADRESSE = doc.data().adresse;
                    ligne.LICENCE = doc.data().licence;
                    ligne.EMAIL = doc.data().email;
                    ligne.TEL = doc.data().tel;
                    for (var customId in this.club.customs) {
                        if (typeof(doc.data().customs) != "undefined")
                            ligne[customId] = doc.data().customs[customId];
                    }
                    this.membres.push(ligne);
                    this.progressValue = Math.round(index / joueurDocs.docs.length);
                    
                })
                
            if (joueurDocs.docs.length==0) {
                    var ligne = {};
                ligne.ID = "";
                ligne.PSEUDO = "";
                ligne.NOM = "";
                ligne.PRENOM = "";
                ligne.ADRESSE = "";
                ligne.LICENCE = "";
                ligne.EMAIL = "";
                ligne.TEL = "";
                for (var customId in this.club.customs) {
                    ligne[customId] = "";
                }
                   this.membres.push(ligne);
                    
            }
            
        },
    async onexport () { // On Click Excel download button
            await this.loadData();
            // export json to Worksheet of Excel
            // only array possible
            var membres = XLSX.utils.json_to_sheet(this.membres) 
            

            // A workbook is the name given to an Excel file
            var wb = XLSX.utils.book_new() // make Workbook of Excel

            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            XLSX.utils.book_append_sheet(wb, membres, 'membres') // sheetAName is name of Worksheet

            // export Excel file
            XLSX.writeFile(wb, this.nameFile) // name of the file is 'book.xlsx'
    }
  }
}
</script>